export default "__VITE_ASSET__i9aFFbu6__"